<template>
  <div class="index">
    <div class="content-box">
      <div class="user-info">
        <!-- <el-avatar class="head-icon" :src="userInfo.avatar"></el-avatar> -->
        <div class="box-title">
          <div>个人信息</div>
          <!-- <img src="/static/icon/user-icon.png" /> -->
          <div class="editBox">
<!--            <img
              @click="isInput = !isInput"
              style="cursor: pointer"
              src="/static/icon/edite-icon.png"
            />-->
            <i class="el-icon-edit-outline" @click="isInput = !isInput"></i>
            编辑
          </div>

        </div>
        <div class="newustop">
          <el-upload
            class="userInfo.avatar?'avatar-uploader':avatarborder avatar-uploader"
            :action="baseUrl + '/business/user/updateAvatar'"
            :show-file-list="false"
            :headers="{
              Authorization: gettoken,
            }"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
            name="avatarFile"
          >
            <img v-if="userInfo.avatar" :src="userInfo.avatar" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <div class="user-name">
            {{
              userInfo.nickName ? userInfo.nickName : "用户" + userInfo.userName
            }}
          </div>
          <div class="justify-between">
            <div class="read-list">
              <img
                style="width: 24px; height: 24px"
                src="/static/search/sibu.png"
              />
              {{ bookData.total || 0 }}
            </div>
            <div class="shuline"></div>
            <div class="read-list">
              <img
                style="width: 28px; height: 26px"
                src="/static/search/chaodai.png"
              />
              {{ noteData.total || 0 }}
            </div>
            <div class="shuline"></div>
            <!-- <div class="read-list">
              <img
                style="width: 28.3px; height: 27px"
                src="/static/icon/collection.png"
              />
              {{ collectData.total || 0 }}
            </div> -->
            <!-- <div class="shuline"></div> -->
            <div class="read-list">
               <i class="el-icon-edit"></i>
<!--              <img style="height: 28px" src="/static/icon/note.png" />-->
              {{ tableData.total || 0 }}
            </div>
          </div>
        </div>

        <div class="user center">
          <div class="user-box">
            <!-- <div class="between">
              <label>暱稱：</label>
              <span>{{ userInfo.nickName }}</span>
            </div>
            <div class="between">
              <label>機構：</label>
              <el-tag type="success" v-if="userInfo.organization">{{
                userInfo.organization
              }}</el-tag>
            </div>
            <div class="between">
              <label>郵箱：</label>
              <span>{{ userInfo.mail }}</span>
            </div>
            <div class="between">
              <label>學歷：</label>
              <span>
                {{ userInfo.qualification }}
              </span>
            </div>
            <div class="between">
              <label>專業：</label>
              <span>
                {{ userInfo.major }}
              </span>
            </div> -->
            <el-form ref="form" :model="userInfo" label-width="60px">
              <el-form-item label="昵称：">
                <span v-show="!isInput" class="fontstyle">{{
                  userInfo.nickName
                }}</span>
                <el-input
                  v-show="isInput"
                  v-model="userInfo.nickName"
                ></el-input>
              </el-form-item>
              <el-form-item label="手机：">
                <span class="fontstyle">{{ userInfo.mobile }}</span>
              </el-form-item>
              <el-form-item label="机构：">
                <span class="fontstyle" v-show="!isInput">
                  {{ userInfo.organization }}</span
                >
                <el-input
                  v-show="isInput"
                  v-model="userInfo.organization"
                ></el-input>
              </el-form-item>
              <el-form-item label="邮箱：">
                <span class="fontstyle" v-show="!isInput">
                  {{ userInfo.mail }}</span
                >
                <el-input v-show="isInput" v-model="userInfo.mail"></el-input>
              </el-form-item>
<!--              <el-form-item label="学历：">
                <span class="fontstyle" v-show="!isInput">{{
                  userInfo.qualification
                }}</span>
                <el-input
                  v-show="isInput"
                  v-model="userInfo.qualification"
                ></el-input>
              </el-form-item>
              <el-form-item label="专业：">
                <span class="fontstyle" v-show="!isInput">{{
                  userInfo.major
                }}</span>
                <el-input v-show="isInput" v-model="userInfo.major"></el-input>
              </el-form-item>-->

              <!-- <el-form-item label="賬户類型：">
                <span class="fontstyle" v-show="!isInput">{{
                  userInfo.rankId
                }}</span>
              </el-form-item>
              <el-form-item label="到期時間：">
                <span class="fontstyle" v-show="!isInput">{{
                  userInfo.vipValidityDate
                }}</span>
              </el-form-item> -->
            </el-form>

            <div class="zh-between">
              <label>账号类型：</label>
              <ul>
                <li v-if="userInfo.rankName">
                  <span>{{ userInfo.rankName }}</span>
                  <el-tag v-if="ismature" type="danger" size="small">已过期</el-tag>
<!--                  <span v-if="ismature" class="smallfont">（已过期）</span>-->
                </li>
                <!-- <li><span>年卡年卡年卡年卡年卡年卡年卡年卡</span></li>
                <li><span>年卡</span></li>
                <li><span>年卡</span></li> -->
                <li
                  v-if="!userInfo.rankName || ismature"
                  v-for="(comp, index) in userInfo.companyList"
                  :key="index"
                >
                  <span>{{ comp }}</span>
                </li>
              </ul>
            </div>
            <!-- :class="ismature ? 'redicon' : ''" -->
            <!--  -->
            <div class="between" v-if="userInfo.rankName && !ismature">
              <label>会员卡到期时间：</label>
              <span>{{ userInfo.vipValidityDate }}</span>
            </div>
            <div
              class="between"
              v-if="userInfo.companyList && userInfo.companyList.length > 0"
            >
              <label>集团有效期：</label>
              <span>{{ userInfo.companyValidityDate }}</span>
            </div>

            <!--
            <div class="tag-block center">綁定卡號</div> -->
            <!-- <el-button type="primary" size="small" @click="editUserInfo"
              >确认</el-button
            > -->
            <div
              class="tag-block center"
              v-show="isInput"
              @click="editUserInfo"
            >
              确认
            </div>
            <!-- <div
              class="tag-block center"
              @click="$router.push({ path: '/products' })"
            >
              充值中心
            </div> -->
            <div class="bandcardstyle" v-if="isShowCardBox">
              <el-input
                style="width: 78%"
                v-model="cardNo"
                placeholder="请输入集团阅读卡号"
              ></el-input>
              <div
                v-if="cardNo"
                style="width: 20%"
                class="querenbut"
                @click="bandCompKar"
              >
                确认
              </div>
              <div
                v-else
                style="width: 20%"
                class="querenbut"
                @click="showCardBox"
              >
                取消
              </div>
            </div>
            <!-- <div v-else class="tag-block center" @click="showCardBox">
              <span>绑定集团阅读卡</span>
            </div> -->
            <div class="tag-block center" @click="getout">退出登录</div>
          </div>
        </div>
      </div>
      <div class="content">
        <el-tabs v-model="activeName">
          <el-tab-pane label="我的阅读" name="read"></el-tab-pane>
          <el-tab-pane label="我的笔记" name="note"></el-tab-pane>
          <!-- <el-tab-pane label="我的收藏" name="collect"></el-tab-pane> -->
          <el-tab-pane label="我的订单" name="order"></el-tab-pane>
          <el-tab-pane label="我的书单" name="readlist"></el-tab-pane>
          <el-tab-pane label="检索记录" name="latest"></el-tab-pane>
          <el-tab-pane label="反馈中心" name="feedBack"></el-tab-pane>
          <!-- <el-tab-pane label="系统书单" name="systembook"></el-tab-pane> -->
        </el-tabs>
        <!-- <div v-if="activeName == 'collect'">
          <el-card
            class="box-card"
            v-for="item in collectData.rows"
            :key="item.bookId"
          >
            <img
              class="img imgbccolor"
              :src="baseUrl + item.busBook.coverImage"
            />
            <div class="layer center">
              <div class="sm-title flex-col justify-center">
                <router-link
                  class="align-center center"
                  :to="
                    '/read?bookId=' +
                    item.bookId +
                    '&bookName=' +
                    item.busBook.bookName +
                    '&juanNum=1&pageId=1'
                  "
                >
                  <img src="/static/icon/eye.png" />
                  查看文獻
                </router-link>

                <div
                  class="align-center center"
                  @click="deleteFavor(item.favorId)"
                >
                  <img src="/static/icon/delete-a.png" />
                  删除
                </div>
              </div>
            </div>
          </el-card>
          <div class="center">
            <el-pagination
              background
              :current-page="collectData.pageNum"
              layout="prev, pager, next"
              @current-change="getPageNum"
              :page-size="collectData.pageSize"
              :total="collectData.total"
            >
            </el-pagination>
          </div>
        </div> -->
        <div v-if="activeName == 'read'">
          <!-- <el-card class="box-card">
            <img
              class="img imgbccolor"
              style="width: 100%; height: auto"
              src="
               /static/detail/readbook.jpg
              "
            />
            <div class="bottomtext">
              <span>好吃的汉堡好吃的汉堡好吃的汉堡好吃的汉堡</span>
            </div>

            <div class="layer center">
              <div class="sm-title flex-col justify-center">
                <router-link class="align-center center">
                  <img src="/static/icon/eye.png" />
                  查看
                </router-link>

                <div class="align-center center">
                  <img src="/static/icon/delete-a.png" />
                  删除
                </div>
              </div>
            </div>
          </el-card> -->

<!--          <el-card
            class="box-card"
            v-for="item in bookData.rows"
            :key="item.bookId"
            v-loading="bokdataloading"
          >
            <el-collapse-transition>
&lt;!&ndash;              <img
                class="img imgbccolor"
                style="width: 100%; height: auto"
                :src="
                  item.busBook.coverImage
                    ? baseUrl + item.busBook.coverImage
                    : '/static/detail/readbook.jpg'
                "
              />&ndash;&gt;
              <img
                v-if="item.busBook.categoryName && item.busBook.categoryName.includes('其他')"
                src="/static/homenew/5.jpg"
                alt=""
                style="width: 100%; height: auto"
              />
              <img
                v-else-if="item.busBook.categoryName && item.busBook.categoryName.includes('經部')"
                src="/static/homenew/1.jpg"
                alt=""
                style="width: 100%; height: auto"
              />
              <img
                v-else-if="item.busBook.categoryName && item.busBook.categoryName.includes('史部')"
                src="/static/homenew/2.jpg"
                alt=""
                style="width: 100%; height: auto"
              />
              <img
                v-else-if="item.busBook.categoryName && item.busBook.categoryName.includes('子部')"
                src="/static/homenew/3.jpg"
                alt=""
                style="width: 100%; height: auto"
              />
              <img v-else src="/static/homenew/4.jpg" alt=""
                   style="width: 100%; height: auto"/>
            </el-collapse-transition>
            <div class="bottomtext">
              <span>{{ item.busBook.bookName }}</span>
              <el-collapse-transition>
                <div class="layer center newlayer">
                  <div class="sm-title sm-titlen">
                    <div
                      class="align-center center newcenter"
                      @click="gotoRead(item)"
                    >
                      <img src="/static/homenew/see.png" />
                      查看
                    </div>
                    <p class="newcenter">|</p>
                    <div
                      class="align-center center newcenter"
                      @click="deleteRead(item.bookId)"
                    >
                      <img src="/static/homenew/delete.png" />
                      删除
                    </div>
                  </div>
                </div>
              </el-collapse-transition>
            </div>

            &lt;!&ndash; :to="'/read' + getBookReadParam(item)" &ndash;&gt;
            &lt;!&ndash; <div class="layer center">
              <div class="sm-title flex-col justify-center">
                <div class="align-center center" @click="gotoRead(item)">
                  <img src="/static/icon/eye.png" />
                  查看
                </div>

                <div
                  class="align-center center"
                  @click="deleteRead(item.bookId)"
                >
                  <img src="/static/icon/delete-a.png" />
                  删除
                </div>
              </div>
            </div> &ndash;&gt;
          </el-card>-->

<!--          <div class="center">
            <el-pagination
              background
              :current-page="bookData.pageNum"
              layout="prev, pager, next"
              @current-change="getNookNum"
              :page-size="bookData.pageSize"
              :total="bookData.total"
            >
            </el-pagination>
          </div>-->
          <div class="select-content flex-grow">
            <div class="booklist">
              <div class="booklistc" v-if="bookData.rows && bookData.rows.length">
                <div class="booklisten">
                  <div
                    class="bookitem"
                    v-for="item in bookData.rows"
                    :key="item.bookId"
                    v-loading="bokdataloading"
                  >
                    <div class="leftimg" @click.stop="gotoRead(item)">
                      <img
                        v-if="item.busBook.categoryName && item.busBook.categoryName.includes('其他')"
                        src="/static/homenew/5New.png"
                        alt=""
                        style="width: 139px;height: 174px;"
                      />
                      <img
                        v-else-if="item.busBook.categoryName && item.busBook.categoryName.includes('經部')"
                        src="/static/homenew/1New.png"
                        alt=""
                        style="width: 139px;height: 174px;"
                      />
                      <img
                        v-else-if="item.busBook.categoryName && item.busBook.categoryName.includes('史部')"
                        src="/static/homenew/2New.png"
                        alt=""
                        style="width: 139px;height: 174px;"
                      />
                      <img
                        v-else-if="item.busBook.categoryName && item.busBook.categoryName.includes('子部')"
                        src="/static/homenew/3New.png"
                        alt=""
                        style="width: 139px;height: 174px;"
                      />
                      <img v-else src="/static/homenew/4New.png" alt=""
                           style="width: 139px;height: 174px;"/>
                    </div>
                    <div class="righttext">
                      <div class="topbox" @click.stop="gotoRead(item)">
                        <p class="toptext" :title="item.busBook.bookName">{{ item.busBook.bookName }}</p>
                      </div>
                      <div class="bookListStyle" @click="deleteRead(item.bookId)">
                        <i class="el-icon-delete" style="font-size: 14px;color: #DBB054"></i>
                        删除
                      </div>
                    </div>
                  </div>
                  <div  style="width:100%;margin: 20px auto; text-align: center;padding-bottom: 15px">
                    <el-pagination
                      background
                      :current-page="bookData.pageNum"
                      layout="prev, pager, next"
                      @current-change="getNookNum"
                      :page-size="bookData.pageSize"
                      :total="bookData.total"
                    >
                    </el-pagination>
                  </div>
                </div>

              </div>
              <div  v-else style="margin:auto">
                <el-empty
                  :image-size="200"
                  :description=description
                  image="/static/icon/1.gif"
                ></el-empty>
              </div>

              <!-- <div class="bookitem">
                <div class="leftimg">
                  <img src="/static/detail/book.jpg" alt="" />
                </div>
                <div class="righttext">
                  <p class="toptext">六韜</p>
                  <p class="bottomtext">
                    [春秋] 鄧析 撰·四部叢刊景明本·北京大學-字節跳動古籍開放文本庫
                  </p>
                </div>
              </div>
              <div class="bookitem">
                <div class="leftimg">
                  <img src="/static/detail/book.jpg" alt="" />
                </div>
                <div class="righttext">
                  <p class="toptext">六韜</p>
                  <p class="bottomtext">
                    [春秋] 鄧析 撰·四部叢刊景明本·北京大學-字節跳動古籍開放文本庫
                  </p>
                </div>
              </div>
              <div class="bookitem">
                <div class="leftimg">
                  <img src="/static/detail/book.jpg" alt="" />
                </div>
                <div class="righttext">
                  <p class="toptext">六韜</p>
                  <p class="bottomtext">
                    [春秋] 鄧析 撰·四部叢刊景明本·北京大學-字節跳動古籍開放文本庫
                  </p>
                </div>
              </div>
              <div class="bookitem">
                <div class="leftimg">
                  <img src="/static/detail/book.jpg" alt="" />
                </div>
                <div class="righttext">
                  <p class="toptext">六韜</p>
                  <p class="bottomtext">
                    [春秋] 鄧析 撰·四部叢刊景明本·北京大學-字節跳動古籍開放文本庫
                  </p>
                </div>
              </div> -->
              <!-- <p v-if="newloading">加载中...</p>
              <p v-if="noMore">以上就是本次檢索的所有結果</p> -->
            </div>
          </div>
        </div>
        <div v-if="activeName == 'note'" style="min-height: 627px">
          <div class="justify-end">
            <!-- <el-button class="btn active" @click="downNote">
              <span class="center"> -->
            <!-- <img src="/static/icon/uc-export.png" /> -->
            <!-- <i class="iconfont icon-xiazai"></i>
                批量導出</span
              >
            </el-button> -->

            <el-button class="btn center" @click="deleteNotes()" >
              <span class="align-center center" style="display: block">
                <i class="el-icon-delete"></i>批量删除</span
              >
            </el-button>
          </div>
          <!-- <el-checkbox-group v-model="checkList" @change="checkListChange"> -->
          <div style="display: flex;flex-wrap: wrap">
            <el-card
              class="list-card"
              v-for="item in noteData.rows"
              :key="item.bookId"
            >
              <div class="justify-end batch-btn">
                <a></a>
              </div>

              <div class="between align-center">
                <el-checkbox
                  @change="checkListChange(item.bookId)"
                  :key="item.bookId"
                  :value="checkList.findIndex((d) => d == item.bookId) > -1"
                ></el-checkbox>
                <div class="grow flex book-info">
<!--                  <img
                    class="img imgbccolor"
                    :src="
                    item.coverImage
                      ? baseUrl + item.coverImage
                      : '/static/detail/book.jpg'
                  "
                  />-->
                  <img
                    v-if="item.categoryName.includes('其他')"
                    src="/static/homenew/5New.png"
                    alt=""
                    style="width: 139px;height: 174px;"
                  />
                  <img
                    v-else-if="item.categoryName.includes('經部')"
                    src="/static/homenew/1New.png"
                    alt=""
                    style="width: 139px;height: 174px;"
                  />
                  <img
                    v-else-if="item.categoryName.includes('史部')"
                    src="/static/homenew/2New.png"
                    alt=""
                    style="width: 139px;height: 174px;"
                  />
                  <img
                    v-else-if="item.categoryName.includes('子部')"
                    src="/static/homenew/3New.png"
                    alt=""
                    style="width: 139px;height: 174px;"
                  />
                  <img v-else src="/static/homenew/4New.png" alt=""
                       style="width: 139px;height: 174px;"/>
<!--                  <img
                    v-if="item.categoryName.includes('其他')"
                    src="/static/homenew/5New.png"
                    alt=""
                    style="width: 139px;height: 174px;"
                    @click.stop="gotoRead(item)"
                  />
                  <img
                    v-else-if="item.categoryName.includes('經部')"
                    src="/static/homenew/1New.png"
                    alt=""
                    style="width: 139px;height: 174px;"
                    @click.stop="gotoRead(item)"
                  />
                  <img
                    v-else-if="item.categoryName.includes('史部')"
                    src="/static/homenew/2New.png"
                    alt=""
                    style="width: 139px;height: 174px;"
                    @click.stop="gotoRead(item)"
                  />
                  <img
                    v-else-if="item.categoryName.includes('子部')"
                    src="/static/homenew/3New.png"
                    alt=""
                    style="width: 139px;height: 174px;"
                    @click.stop="gotoRead(item)"
                  />
                  <img v-else src="/static/homenew/4New.png" alt="" @click.stop="gotoRead(item)"
                       style="width: 139px;height: 174px;"/>-->
                  <div
                    class="flex-col "
                    style="cursor: pointer"
                    @click="getnotedetail(item)"
                  >
                    <div class="title justify-between">
                      <div :title="item.bookName">{{ truncateText(item.bookName) }}</div>
                      <div class="totalBox">共 {{ item.noteCount }} 处笔记</div>
                    </div>
                    <div class="desc">最近阅读时间:&nbsp;{{ formatDateTime(item.createTime) }}</div>
                    <div class="lookCancel">
                      <div
                        slot="reference"
                        @click="getnotedetail(item)"
                      >
                        <!--                        <img src="/static/icon/eye.png" />-->
                        <i style="color: #DBB054" class="el-icon-view"></i>&nbsp;&nbsp;
                        查看
                      </div>
                      <!-- <router-link
                        target="_blank"
                        class="align-center center"
                        :to="'/read' + formParam(item) + '&source=uc'"
                      >
                        <img src="/static/icon/eye.png" />
                        查看
                      </router-link> -->

                      <div
                        class="align-center center"
                        @click="deleteNotes(item.bookId)"
                      >
                        <!--                        <img src="/static/icon/delete-a.png" />-->
                        <i style="color: #DBB054" class="el-icon-delete"></i>&nbsp;&nbsp;
                        删除
                      </div>
                    </div>
                  </div>
                </div>


              </div>
            </el-card>
          </div>

          <!-- </el-checkbox-group> -->
          <div class="justify-end">
            <el-pagination
              :current-page="noteData.pageNum"
              layout="prev, pager, next,total"
              size="small"
              @current-change="getNotePageNum"
              :page-size="noteData.pageSize"
              :total="noteData.total"
            >
            </el-pagination>
          </div>
        </div>
        <div v-if="activeName == 'order'" class="flex-col" style="min-height: 627px">
          <el-card class="cover">
            <!-- <div class="center">敬请期待</div> -->
            <el-table
              ref="multipleTable"
              :data="orderList"
              tooltip-effect="dark"
              style="width: 100%"
              @selection-change="handleSelectionChange"
              :default-sort="{ prop: 'createTime', order: 'descending' }"
            >
              <el-table-column type="selection"> </el-table-column>
              <el-table-column label="订单类型" prop="orderName">
                <!-- <template slot-scope="scope">
                  <li class="kaitem">
                    <img :src="baseUrl + scope.row.orderIcon" alt="" />
                  </li>
                </template> -->
              </el-table-column>
              <el-table-column
                prop="orderNum"
                label="订单编号"
                width="160"
                sortable
              >
              </el-table-column>
              <el-table-column
                prop="createTime"
                label="下单时间"
                show-overflow-tooltip
                sortable
              >
              </el-table-column>
              <!-- <el-table-column
                label="訂單狀態"
                show-overflow-tooltip
                sortable
                sort-by="payStatus"
              >
                <template slot-scope="scope">{{
                  payStatus[scope.row.payStatus]
                }}</template>
              </el-table-column> -->
              <el-table-column
                prop="realTotal"
                label="订单金额"
                show-overflow-tooltip
                sortable
              >
              </el-table-column>
              <!-- <el-table-column label="操作" class="caozuo">
                <template slot-scope="scope">
                  <button
                    v-if="scope.row.payStatus == 0 || scope.row.payStatus == 5"
                    class="qxbutton zfbutton"
                    @click="zhifuOrder(scope.row.orderId)"
                  >
                    支付
                  </button>
                  <button
                    v-if="
                      scope.row.payStatus == 3 ||
                      scope.row.payStatus == 4 ||
                      scope.row.payStatus == 5 ||
                      scope.row.payStatus == 6 ||
                      scope.row.payStatus == 0
                    "
                    class="qxbutton"
                    @click="cancelOrder(scope.row.orderId)"
                  >
                    取消
                  </button>
                </template>
              </el-table-column> -->
            </el-table>
            <el-pagination
              layout="prev, pager, next"
              :total="orderListTotal"
              @current-change="orderListPageChange"
            >
            </el-pagination>
          </el-card>
        </div>
        <div v-if="activeName == 'readlist' && !isBookList" style="min-height: 627px">
          <!-- <router-link
                  class="align-center center"
                  :to="'/read' + getBookReadParam(item)"
                >
                  <img src="/static/icon/eye.png" />
                  查看
                </router-link> -->
          <!-- <div
            class="box-readlist"
            v-for="(item, index) in readListparam.rows"
            :key="index"
          >
            <div class="readlistitem" @click="bookListInReadlist(item.listId)">
              <span>{{ item.listName }}</span
              ><span>书数：{{ item.bookCount }}本</span
              ><span>{{ item.description }}</span
              ><span>创建：{{ item.createTime }}</span>
            </div>

            <div class="layer center">
              <div class="sm-title justify-center">

                <div
                  class="align-center center"
                  style="margin-bottom: 0; margin-right: 8px; color: #0e6e7f"
                  @click="appeareditreadlist(index)"
                >
                  编辑
                </div>

                <div
                  class="align-center center"
                  style="margin-bottom: 0; margin-right: 8px; color: #0e6e7f"
                  @click="bookListInReadlist(item.listId)"
                >
                  详情
                </div>

                <div
                  class="align-center center"
                  @click="deleteReadList(item.listId)"
                  style="color: #0e6e7f"
                >
                  删除
                </div>
              </div>
            </div>
          </div> -->
          <div class="booklist">
            <div
              class="booklistcon"
              v-for="(item, index) in readListparam.rows"
              :key="index"
              @click="bookListInReadlist(item.listId)"
            >
              <div class="booklistconse">
                <div class="imgcontent">
                  <img src="/static/homenew/1.jpg" alt="" />
                </div>
                <div class="textcontent">
                  <div class="texttitle">{{ item.listName }}</div>
                  <div class="setitle">本书单共“{{ item.bookCount }}”本书</div>
<!--                  <div class="textline"></div>-->
                  <div class="bcontent">
                    {{ item.description }}
                  </div>
<!--                  <div class="playimg">
                    <img src="/static/homenew/right.png" alt="" />
                  </div>-->
                </div>
              </div>
            </div>
          </div>

          <div class="center">
            <el-pagination
              background
              :current-page="readListparam.pageNum"
              layout="prev, pager, next"
              @current-change="getNookNum"
              :page-size="readListparam.pageSize"
              :total="readListparam.total"
            >
            </el-pagination>
          </div>
        </div>
        <div v-if="activeName == 'readlist' && isBookList" style="min-height: 627px">
          <div style="text-align: right;float:right;margin-top: 15px">
            <i
              class="el-icon-close"
              @click="isBookList = false"
              style="cursor: pointer; font-size: 18px"
            ></i>
          </div>
<!--          <div style="margin-top: 10px">共:{{ bookList.total }}本书</div>-->
          <span style="line-height: 60px;font-family: PingFangSC, PingFang SC;font-weight: 500;font-size: 18px;color: #573E0D;">书单列表
            <span style="font-family: PingFangSC, PingFang SC;font-weight: 400;font-size: 14px;color: #573E0D;">
         共{{ bookList.total }}本
      </span>
          </span>
          <!-- <div
            class="box-readlist"
            v-for="(item, index) in bookList.rows"
            :key="index"
          >
            <div class="readlistitem">
              <span>{{ item.busBook.bookName }}</span
              ><span>{{ item.busBook.categoryName }}</span
              ><span>{{ item.busBook.writer }}</span>
            </div>
            <div class="layer center">
              <div
                class="align-center center"
                style="
                  margin-bottom: 0;
                  margin-right: 10px;
                  font-weight: bold;
                  color: #0e6e7f;
                  font-size: 14px;
                "
                @click="gotoRead(item)"
              >
                阅读
              </div>
              <div class="sm-title justify-center">
                <div
                  class="align-center center"
                  @click="deleteReadListBooks(item.listId, item.busBook.bookId)"
                  style="color: #0e6e7f"
                >
                  删除
                </div>
              </div>
            </div>
          </div> -->
          <div class="newbooklist">
            <div class="booklistc">
              <div class="booklisten">
                <div
                  class="bookitem"
                  v-for="(item, index) in bookList.rows"
                  :key="index"
                >
<!--                  <div class="leftimg" @click.stop="gotoRead(item)">
                    &lt;!&ndash; @click="
                  $router.push({
                    name: 'Read',
                    query: {
                      bookId: item.id,
                      bookName: item.bookName,
                    },
                  })
                " &ndash;&gt;
                    <img src="/static/detail/book.jpg" alt="" />
                  </div>
                  <div class="righttext" @click.stop="gotoRead(item)">
                    <p class="toptext">{{ item.busBook.bookName }}</p>
                    <div class="newbottomtext">
                      <p>{{ item.busBook.writer }}</p>
                      <p>{{ item.busBook.categoryName }}</p>
                      <p>{{ item.busBook.bookVersion }}</p>
                    </div>
                  </div>-->
                  <div class="leftimg">
                    <!-- @click="
                      $router.push({
                        name: 'Read',
                        query: {
                          bookId: item.id,
                          bookName: item.bookName,
                        },
                      })
                    " -->
                    <img
                      v-if="item.busBook.categoryName.includes('其他')"
                      src="/static/homenew/5.jpg"
                      alt=""
                      style="width: 139px;height: 174px;"
                      @click.stop="gotoRead(item)"
                    />
                    <img
                      v-else-if="item.busBook.categoryName.includes('經部')"
                      src="/static/homenew/1.jpg"
                      alt=""
                      style="width: 139px;height: 174px;"
                      @click.stop="gotoRead(item)"
                    />
                    <img
                      v-else-if="item.busBook.categoryName.includes('史部')"
                      src="/static/homenew/2.jpg"
                      alt=""
                      style="width: 139px;height: 174px;"
                      @click.stop="gotoRead(item)"
                    />
                    <img
                      v-else-if="item.busBook.categoryName.includes('子部')"
                      src="/static/homenew/3.jpg"
                      alt=""
                      style="width: 139px;height: 174px;"
                      @click.stop="gotoRead(item)"
                    />
                    <img v-else src="/static/homenew/4.jpg" alt="" @click.stop="gotoRead(item)"
                         style="width: 139px;height: 174px;"/>
                  </div>
                  <div class="righttext" @click.stop="gotoRead(item)">
                    <div class="topbox" @click.stop="gotoRead(item)">
                      <p class="toptext" :title="item.busBook.bookName">{{ item.busBook.bookName }}</p>
                    </div>
                    <div class="bottomtext" @click.stop="gotoRead(item)">
                      <p>{{ item.busBook.writer }}</p>
                      <p>{{ item.busBook.bookVersion }}</p>
                      <p>{{ item.busBook.categoryName }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="activeName == 'latest'" style="min-height: 627px">
          <el-table :data="gridData" @row-click="goInfor">
            <el-table-column
              property="createTime"
              label="日期"
            ></el-table-column>
            <el-table-column property="typestr" label="记录">
              <!-- <template slot-scope="props">
                <el-link
                  type="primary"
                  @click="historyTo(props.row)"
                  :underline="false"
                  >{{ historyList[props.row.operType] }}</el-link
                >
              </template> -->
            </el-table-column>
          </el-table>
          <el-pagination
            style="margin: 20px auto; text-align: center"
            small
            layout="prev, pager, next"
            :total="gridtotal"
            @current-change="pageChange"
            :current-page="gridpageNum"
            :page-size="gridpageSize"
          >
          </el-pagination>
        </div>
        <div v-if="activeName == 'feedBack'" style="min-height: 627px">
          <el-table :data="backData">
            <el-table-column
              property="createTime"
              label="时间"
            ></el-table-column>
            <el-table-column property="feedbackInfo" label="问题描述">
            </el-table-column>
            <el-table-column
              property="contentName"
              label="原文"
            ></el-table-column>
            <el-table-column
              property="dealInfo"
              label="反馈描述"
            ></el-table-column>
            <el-table-column
              property="status"
              label="状态"
            >
              <template slot-scope="scope">
                <el-tag
                  :type="{2:'warning',0:'info',1:'success'}[scope.row.status]">{{{2:'已取消',0:'待处理',1:'已处理'}[scope.row.status]}}</el-tag>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            style="margin: 20px auto; text-align: center"
            small
            layout="prev, pager, next"
            :total="backTotal"
            @current-change="pageChangeBack"
            :current-page="backpageNum"
            :page-size="backpageSize"
          >
          </el-pagination>
        </div>
      </div>

      <el-dialog title="修改书单" top="80vh" :visible.sync="dialogFormVisible">
        <el-form :model="form">
          <el-form-item label="书单名称" :label-width="formLabelWidth">
            <el-input v-model="form.listName" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="书单描述" :label-width="formLabelWidth">
            <el-input
              type="textarea"
              v-model="form.description"
              autocomplete="off"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button class="submit-btn" @click="dialogFormVisible = false"
            >取 消</el-button
          >
          <el-button
            class="submit-btn"
            type="primary"
            @click="editreadinglist()"
            >确 定</el-button
          >
        </div>
      </el-dialog>

      <el-dialog
        width="70%"
        height="70vh"
        trigger="click"
        :visible.sync="dialogVisibletwo"
      >
        <el-table
          :data="noteList.data"
          style="width: 100%; height: 70vh; overflow: auto"
          :default-sort="{
            prop: 'createTime',
            order: 'descending',
          }"
          @sort-change="paixuNode"
        >
          <!-- <el-table-column
            width="100"
            property="juanNum"
            label="卷"
            sortable
          ></el-table-column> -->
          <el-table-column
            property="juanName"
            sortable="custom"
            label="卷名"
          ></el-table-column>
          <el-table-column
            property="noteTarget"
            label="选择文字"
          ></el-table-column>
          <el-table-column
            property="noteContent"
            label="笔记"
          ></el-table-column>
          <el-table-column
            property="createTime"
            label="创建时间"
            sortable
          ></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <!-- <el-button
                            size="mini"
                            @click="handleEdit(scope.$index, scope.row)"
                            >编辑</el-button
                          >

                          <div
                            class="align-center center"
                            @click="handleDelete(scope.row.noteId)"
                          >
                            <img src="/static/icon/delete-a.png" />
                            删除
                          </div>
                          :to="`/read?bookId=${xzlist.bookId}&bookName=${xzlist.bookName}&noteId=${scope.row.noteId}&xmlIc=${scope.row.xmlId}&juanNum=${scope.row.juanNum}&source=uc`"
                          -->

              <div class="layer">
                <div class="sm-title flex-col align-center">
                  <!-- <router-link
                    class="align-center"
                    :to="`/read?bookId=${xzlist.bookId}&bookName=${xzlist.bookName}&juanNum=${scope.row.beginPage}`"
                    style="text-decoration-line: none; color: #3366cc"
                  >
                    <img src="/static/icon/edite-icon.png" class="dialogimg" />
                    编辑
                  </router-link> -->
                  <div
                    class="align-center pointe"
                    style="margin-top: 20px"
                    @click="handleDelete(scope.row.noteId)"
                  >
                    <img src="/static/icon/delete-a.png" class="dialogimg" />
                    删除
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          :current-page="noteList.pageNum"
          layout="prev, pager, next,total"
          size="small"
          @current-change="getNoteDetailPageNum"
          :page-size="noteList.pageSize"
          :total="noteList.total"
        >
        </el-pagination>
      </el-dialog>

      <el-dialog
        title="提示"
        :visible.sync="dialogVisible"
        width="800px"
        top="20vh"
      >
        <div class="flex vip-card">
          <div class="grow">
            <h2 class="title">开通/续费会员</h2>
            <p style="margin: 36px 0">
              欲升级为付费用户，请在下方输入您的阅读卡编号和密码。
              获取阅读卡，可前往北京大学出版社官方<el-link type="primary"
                >淘宝店</el-link
              >
              或<el-link type="primary">微店</el-link>。
            </p>
            <div class="card-ipt">
              <el-input v-model="No" placeholder="请输入阅读卡编号"></el-input>
            </div>
            <div class="card-ipt">
              <el-input
                v-model="pwd"
                :show-password="true"
                type="password"
                placeholder="请输入阅读卡编号"
              ></el-input>
            </div>
            <div class="card-ipt">
              <el-button type="primary" style="width: 100%">确认</el-button>
            </div>
          </div>
          <div class="grow explain">
            <h5 class="margin24">账户权限说明</h5>
            <h6 class="margin24">未登录用户</h6>
            <p>仅能浏览网站首页、数字展示板块，无法阅读书籍。</p>

            <h6 class="margin24">注册用户</h6>
            <p>
              可以阅读每本书的前 50
              页。如果用户阅读时用关键词检索，且检索文本出现的位置超出前 50
              页，只显示页码数和约 200 字上下文。

              <br />无法使用文本分析、笔记批注功能。
            </p>
            <h6 class="margin24">付费用户</h6>
            <p>
              包括机构用户和个人用户，可全库阅读，并使用文本分析、笔记批注功能。欲升级账户，可在“帐户升级”弹窗内输入您购买的官方阅读卡信息。
              了解阅读卡详情，可前往北京大学出版社官方淘宝店或微店。
            </p>
          </div>
        </div>
        <span slot="footer" class="dialog-footer"> </span>
      </el-dialog>

      <payPage
        :centerDialogVisible="centerDialogVisible"
        :orderId="orderId"
        v-if="centerDialogVisible"
        @changeVisible="doChangeVisible"
      ></payPage>
      <memberRemind></memberRemind>
    </div>
  </div>
</template>
<script>
import eventBus from '@/utils/eventBus.js'
import payPage from '../../components/payPage.vue'
import memberRemind from '../../components/memberRemind.vue'
import {
  getNoteListNew,
  getNoteList,
  getFavordData,
  deleteFavor,
  deleteRead,
  deletBookNote,
  getReadList,
  getInfo,
  exportNotes,
  deleteNotesByBook,
  updateBaseInfo,
  orderList,
  cancelOrder,
  bindCardNo,
  getReadListNew,
  deleteReadList,
  bookListInReadlist,
  delBookByReadList,
  getLatestList,
  getBookQaList
} from '@/api/api'
import {editreadlist} from '../../api/api'
export default {
  name: 'UCindex',
  components: { payPage, memberRemind },
  data () {
    return {
      gridData: [],
      backData: [],
      gridtotal: 0,
      backTotal: 0,
      gridpageNum: 1,
      backpageNum: 1,
      gridpageSize: 10,
      backpageSize: 10,
      bokdataloading: true,
      cardNo: '', // 集團卡號
      isShowCardBox: false, // 是否展示集團卡號輸入框
      isInput: false, // 输入框
      dialogVisibletwo: false,
      noteListParam: {},
      noteList: {
        pageNum: 1,
        pageSize: 12,
        data: [],
        total: 0,
        orderByColumn: 'createTime',
        isAsc: 'desc'
      },
      noteListadd: {
        pageNum: 1,
        pageSize: 12,
        data: [],
        total: 0,
        orderByColumn: 'createTime',
        isAsc: 'desc'
      },
      userInfo: {},
      activeName: '',
      baseUrl: window.__baseUrl__,

      No: '',
      pwd: '',
      checkList: [],
      collectData: {
        pageNum: 1,
        pageSize: 12,
        rows: [],
        total: 0
      },
      noteData: {
        pageNum: 1,
        pageSize: 10,
        rows: [],
        total: 0
      },
      bookData: {
        pageNum: 1,
        pageSize: 12,
        rows: [],
        total: 0
      },
      tableData: {
        pageNum: 1,
        pageSize: 12,

        total: 0,
        rows: [

        ]
      },
      dialogVisible: false,
      xzlist: {}, // 查看item
      orderList: [], // 订单列表\
      orderListTotal: 0, // 订单数量
      orderListparam: {
        pageNum: 1,
        pageSize: 10,
        status: 1,
        isInvoice: 'N'
      },
      payStatus: ['待付款', '已付款', '已退款', '付款中', '退款中', '付款失败', '退款失败', '已关闭', '交易完成'],
      centerDialogVisible: false,
      orderId: 0,
      // daoqiDialogVisible: true,//到期
      ismature: false, // 是否到期
      readList: [],
      readListparam: {
        pageNum: 1,
        pageSize: 10,
        rows: [],
        total: 0
      },
      bookList: {}, // 书单详情列表
      isBookList: false,
      form: { listName: "", description: "" },
      formLabelWidth: '120px',
      dialogFormVisible: false,
      readlistindex: 0,
    }
  },
  mounted () {
    // 添加点击事件监听
    // document.addEventListener('click', this.handleClick())
    this.getNoteData()
    this.getNoteData(2)
    this.getFavordData()
    this.getReadData()
    this.getReadList()
    this.getLatests()
    this.getBackData()

    this.userInfo = localStorage.userinfo ? JSON.parse(localStorage.userinfo) : {}
    // getInfo().then(d => {
    //   this.userInfo = d.user
    //   this.userInfo.avatar = (this.userInfo.avatar.indexOf('http') == -1) ? this.baseUrl + this.userInfo.avatar : this.userInfo.avatar

    // })
    this.getOrderList()
    this.jugeMature()
  },
  created () {
    if (this.$route.query && this.$route.query.type) {
      this.activeName=this.$route.query.type
    }else {
      this.activeName='read'
    }
  },
  methods: {
    truncateText(text) {
      if (!text) return '';

      // 如果文本长度超过6个字符，显示前6个字符加省略号
      if (text.length > 6) {
        return text.substring(0, 6) + '...';
      }

      // 否则返回原文本
      return text;
    },
    goInfor(row){
      console.log(row.operStr)
      let operstrobj = row.operStr && JSON.parse(row.operStr)
      if (row.operStr && (row.operType == 'search' || row.operType == 'search-in' || row.operType == 2)) {
        // console.log(operstrobj, 'operstrobj')
       // keywordstr = (operstrobj.searchType == '0') ? "一般检索 " + operstrobj.keyword : (operstrobj.searchType == '1') ? "逻辑检索 " + operstrobj.keyword : (operstrobj.searchType == '2') ? "范围检索 " + operstrobj.keyword : "书目检索 " + operstrobj.keyword
       let searchType=operstrobj.searchType
       let keyword=operstrobj.keyword
        let advaList=[]
        if (operstrobj.advaList) {
          advaList=operstrobj.advaList
        }
        this.$router.push({
          name: 'Search',
          query: {
            searchType: searchType,
            keyword: keyword,
            advaList: advaList,
          },
        })
      }
    },
    formatDateTime(isoString) {
      const date = new Date(isoString);

      const pad = num => num.toString().padStart(2, '0');

      const yyyy = date.getFullYear();
      const mm = pad(date.getMonth() + 1);
      const dd = pad(date.getDate());
      const hh = pad(date.getHours());
      const min = pad(date.getMinutes());
      const ss = pad(date.getSeconds());

      return `${yyyy}-${mm}-${dd} ${hh}:${min}:${ss}`;
    },
    getLatests () {
      getLatestList({ pageNum: this.gridpageNum, pageSize: this.gridpageSize }).then((d) => {
        // console.log(d, 'dfsfs')
        if (d.code == 200) {
          let temprows = d.rows
          temprows.forEach((ele) => {
            let operstrobj = ele.operStr && JSON.parse(ele.operStr)
            let keywordstr = ''
            if (ele.operStr && (ele.operType == 'search' || ele.operType == 'search-in' || ele.operType == 2)) {
              // console.log(operstrobj, 'operstrobj')
              keywordstr = (operstrobj.searchType == '0') ? "一般检索 " + operstrobj.keyword : (operstrobj.searchType == '1') ? "逻辑检索 " + operstrobj.keyword : (operstrobj.searchType == '2') ? "范围检索 " + operstrobj.keyword : "书目检索 " + operstrobj.keyword
              if (operstrobj.advaList) {
                operstrobj.advaList.forEach((e) => {
                  keywordstr += `、${e.type ? '(' + e.type + ')' : ''}${e.keyword}${e.spacing ? '(' + e.spacing + ')' : ''}`
                })
              }

            }
            ele.typestr = keywordstr
            ele.operstrobj = operstrobj
          })
          // console.log(temprows, 'temprows')
          this.gridData = temprows
          this.gridtotal = d.total
        }
      })
    },
    getBackData () {
      getBookQaList({ pageNum: this.backpageNum, pageSize: this.backpageSize }).then((d) => {
        // console.log(d, 'dfsfs')
        if (d.code == 200) {
          // console.log(temprows, 'temprows')
          this.backData = d.rows
          this.backTotal = d.total
        }
      })
    },
    gotoRead (item) {
      // $router.push({
      //               name: 'Read',
      //               query: {
      //                 bookId: item.busBook.bookId,
      //                 bookName: item.busBook.bookName,
      //               },
      //             })
      const url = this.$router.resolve("/read?bookId=" + item.busBook.bookId + '&bookName=' + item.busBook.bookName)
      window.open(url.href)
    },
    appeareditreadlist (index) {
      this.readlistindex = index
      console.log(this.readListparam.rows[index], 'this.readListparam.rows[index]')
      this.form.listName = this.readListparam.rows[index].listName
      this.form.description = this.readListparam.rows[index].description
      this.dialogFormVisible = true


    },
    editreadinglist () {
      // console.log(this.readListparam, this.readListparam.rows[this.readlistindex].bookIdList, 'this.readListparam.rows[this.readlistindex].bookIdList')
      editreadlist({ listId: this.readListparam.rows[this.readlistindex].listId, isAdd: 1, listName: this.form.listName, description: this.form.description }).then((d) => {
        if (d.code == 200) {
          this.$message.success('成功')
          this.getReadList()
        } else {
          this.$message.warning('失败')
        }
        this.dialogFormVisible = false
      })
    },
    bookListInReadlist (id) {
      this.isBookList = true
      bookListInReadlist({ listId: id }).then((d) => {
        this.bookList = d
      })
    },

    deleteReadList (id) {
      deleteReadList(id).then(() => {
        this.getReadList()
        // this.getSystemReadList()
        this.$message.success('刪除成功')
      })
    },
    deleteReadListBooks (listId, bookIds) {
      console.log(listId, bookIds, 'listId, bookIds')
      delBookByReadList({ listId, bookIdList: [bookIds] }).then(() => {
        this.bookListInReadlist(listId)
        this.$message.success('刪除成功')
      })

    },
    getReadList () {
      let { pageNum, pageSize } = this.readListparam
      getReadListNew({ pageNum, pageSize }).then(d => {
        // console.log(d)
        this.readListparam.rows = d.rows
        this.readListparam.total = d.total
      })
    },

    // handleClick (event) {
    //   // 处理点击事件
    //   console.log('Clicked at:', event)
    //   // 这里可以根据需要记录更多的信息，例如event.target等
    // },
    // 绑定集团卡
    bandCompKar () {
      bindCardNo(this.cardNo).then((res) => {
        if (res.code == 200) {
          this.$message({
            message: res.msg,
            type: 'success'
          })
          this.cardNo = ''
          this.isShowCardBox = false
          eventBus.$emit('getUserInfo')
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    showCardBox () {
      this.isShowCardBox = !this.isShowCardBox
    },
    jugeMature () {
      this.ismature = !!((this.userInfo && Date.parse(new Date(this.userInfo.vipValidityDate)) <= Date.now()))
      // console.log(this.ismature, 'this.ismature')
    },
    doChangeVisible (newData) {
      this.centerDialogVisible = newData
      this.getOrderList()
    },
    // 取消订单
    cancelOrder (orderId) {
      cancelOrder(orderId).then((res) => {
        if (res.code == 200) {
          this.getOrderList()
          this.$message({
            message: res.msg,
            type: 'success'
          })
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    zhifuOrder (orderId) {
      this.orderId = orderId
      this.centerDialogVisible = true
    },
    getOrderList () {
      orderList(this.orderListparam).then((res) => {
        // console.log(res, 'res')
        this.orderList = res.rows
        this.orderListTotal = res.total
      })
    },
    orderListPageChange (page) {
      this.orderListparam.pageNum = page
      this.getOrderList()
    },
    pageChange (val) {
      this.gridpageNum = val
      this.getLatests()
    },
    pageChangeBack (val) {
      this.backpageNum = val
      this.getBackData()
    },

    paixuNode (colum) {
      if (colum.prop == 'juanName') {
        this.noteList.orderByColumn = 'xmlId'
        this.noteList.isAsc = (colum.order == 'ascending') ? 'asc' : 'desc'
        this.getnotedetail()
      }
    },
    handleAvatarSuccess (res, file) {
      // this.imageUrl = URL.createObjectURL(file.raw)
      // this.userInfo.avatar
      // console.log(res, file, '/business/user/updateAvatar')
      // console.log(res, 'reu')
      if (res.code == 200) {
        this.userInfo.avatar = (res.imgUrl.indexOf('http') == -1) ? this.baseUrl + res.imgUrl : res.imgUrl
        eventBus.$emit('getUserInfo')
        this.$message.success('上传成功')
      } else {
        this.$message.error('上传失败')
      }
    },
    beforeAvatarUpload (file) {
      // console.log(file, 'file')
      let geshi = ['image/jpg', 'image/png', 'image/jpeg']
      // const isJPG = file.type === 'image/jpeg'
      // const isJPG = file.type == "image/jpg"
      // const isPng = file.type == "image/png"
      // const isJpeg = file.type == "image/jpeg"
      const isJPG = geshi.indexOf(file.type) != -1
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 jpg/png/jpeg 格式!')
        return false
      }

      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
        return false
      }
      return isJPG && isLt2M
    },

    editUserInfo () {
      let param = { 'nickName': this.userInfo.nickName, 'organization': this.userInfo.organization, 'mail': this.userInfo.mail, 'qualification': this.userInfo.qualification, 'major': this.userInfo.major }
      updateBaseInfo(param).then((res) => {
        if (res.code == 200) {
          this.$message.success('编辑成功')
          eventBus.$emit('getUserInfo')
          this.isInput = false
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    handleDelete (id) {
      // console.log(scope)
      deletBookNote({ noteId: id }).then(() => {
        this.getnotedetail()
        this.$message.success('刪除成功')
      })
    },
    // 筆記詳情
    getNoteDetailPageNum (e) {
      this.noteList.pageNum = e
      this.getnotedetail()
    },
    // 筆記詳情
    getnotedetail (item = {}, noteType = 1) {
      // console.log(item, 'idd')
      if (item) this.xzlist = item
      this.dialogVisibletwo = true
      // console.log(item)
      if (item.bookId
      ) {
        this.noteList.bookId = item.bookId
      }
      let param = noteType == 1 ? this.noteList : this.noteListadd
      this.noteListParam = { bookId: param.bookId, pageNum: param.pageNum, pageSize: param.pageSize, orderByColumn: param.orderByColumn, isAsc: param.isAsc, noteType: noteType }
      getNoteListNew(this.noteListParam)
        .then(d => {
          // console.log(d, 'ddd')
          if (noteType == 1) {
            this.noteList.data = d.rows.map((obj) => {
              let { juanName, noteTarget, noteContent, createTime, juanNum, noteId } = obj
              return { juanName, noteTarget, noteContent, createTime, juanNum, noteId }
            })
            this.noteList.total = d.total
          } else {
            this.noteListadd.data = d.rows.map((obj) => {
              let { juanName, noteTarget, noteContent, createTime, juanNum, noteId } = obj
              return { juanName, noteTarget, noteContent, createTime, juanNum, noteId }
            })
            this.noteListadd.total = d.total

          }

        })
    },
    // 退出登录
    getout () {
      localStorage.removeItem('token')
      localStorage.removeItem('isVip')
      this.$router.replace({
        path: '/'
      })
      eventBus.$emit('outLogin', 1)
    },
    checkListChange (bookId) {
      const index = this.checkList.findIndex(d => d == bookId)
      if (index > -1) {
        this.checkList.splice(index, 1)
      } else {
        this.checkList.push(bookId)
      }
      this.$forceUpdate()
    },
    getBookReadParam (item) {
      // console.log(item, 'item')
      const {
        bookId,
        juanNum,
        juanName,
        catalogId,
        readPage,
        beginPage,
        endPage
      } = item
      // return this.formParam({
      //   bookId,
      //   juanNum,
      //   bookName: item.busBook.bookName,
      //   catalogName: juanName,
      //   bookPage: readPage,
      //   beginPage,
      //   endPage,
      //   formSearchNotJump: 1,
      //   formSearch: 1
      // })
      return this.formParam({
        bookId,
        bookName: item.busBook.bookName,
        juanNum: beginPage
      })
    },
    getCollect () {
      let { pageNum, pageSize } = this.collectData
    },
    getPageNum (e) {
      this.collectData.pageNum = e
      this.getFavordData()
    },
    getFavordData () {
      getFavordData({
        pageNum: this.collectData.pageNum,
        pageSize: this.collectData.pageSize
      }).then(d => {
        this.collectData.rows = d.rows
        this.collectData.total = d.total
      })
    },
    deleteFavor (id) {
      deleteFavor(id).then(() => {
        this.$message.success('删除成功')
        this.getFavordData()
        this.getNoteData()
      })
    },
    deleteRead (id) {
      deleteRead(id).then(() => {
        this.$message.success('删除成功')
        this.getReadData()
      })
    },
    getNoteData (noteType = 1) {
      let { pageNum, pageSize } = this.noteData
      getNoteList({ pageNum, pageSize, noteType }).then(d => {
        this.noteData.rows = d.rows
        this.noteData.total = d.total
      })
    },
    deletBookNote (item) {
      deletBookNote(item).then(() => {
        this.$message.success('删除成功')
        this.getNoteData()
      })
    },
    getReadData () {
      getReadList({
        pageSize: this.bookData.pageSize,
        pageNum: this.bookData.pageNum
      }).then(d => {
        this.bookData.rows = d.rows
        this.bookData.total = d.total
        this.bokdataloading = false
      })
    },
    getNookNum (item) {
      this.bookData.pageNum = item
      this.getReadData()
    },
    getNotePageNum (e) {
      this.noteData.pageNum = e
      this.getReadList()
    },

    // 订单表格
    toggleSelection (rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row)
        })
      } else {
        this.$refs.multipleTable.clearSelection()
      }
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    downNote () {
      exportNotes().then(d => {
        this.downBlobFile(d, '我的笔记')
      })
    },
    deleteNotes (id) {
      if (!id && !this.checkList.length) {
        return this.$message.warning('请先选择删除项')
      }
      id = id || this.checkList.join()

      deleteNotesByBook({ bookId: id, noteType: 1 }).then(() => {
        this.$message.success('删除成功')
        this.getNoteData()
        this.checkList = []
      })
    }
  },
  computed: {
    gettoken () {
      return localStorage.getItem('token')
    }
  },
  watch: {
    dialogVisibletwo (newVal) {
      // console.log(newVal, 'newVal')
      if (!newVal) {
        this.getNoteData()
      }
    }
  }
  // beforeDestroy(){
  //   window.removeEventListener('click', this.handleClick())
  // }

}
</script>
<style lang="less" scoped>
@import url(../../assets/iconfont.css);
// /deep/ .readimg{
//   width: 156px;
//   height: 190px;
// }
// /deep/ .read .index .content .box-card .img{
//   width: 156px;
//   height: 190px;
// }
@primary-color: #f4f0e8;
@first-color: #2c7e8d;
@secont-color: #666666;
@PingFangSC-Regular: PingFangSC-Regular;
@PingFang-SC-Bold: PingFang-SC-Bold;
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #DBB054;
}
/deep/.el-pager li.active {
  color: #DBB054;
}
/deep/.el-tabs__active-bar {
  background-color: #DBB054;
}
/deep/.el-tabs__item:hover {
  color: #DBB054;
}
/deep/.el-button--primary {
  background: #DBB054;
  border-color: #DBB054;
}
/deep/.el-checkbox__input.is-checked .el-checkbox__inner{
  background: #DBB054;
  border-color: #DBB054;
}
/deep/.el-table .descending .sort-caret.descending{
  border-top-color: #DBB054;
}
/deep/.el-table .ascending .sort-caret.ascending{
  border-bottom-color: #DBB054;
}
.newustop {
  //background: url("/static/homenew/ucback.png") no-repeat;
  background-size: 100% 100%;
  margin: 0 20px 20px;
  border-bottom:1px solid #EDE7D8;
  padding-bottom: 20px;
}
.booklist {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  .booklistcon {
    margin: 20px 0;
    width: 376px;
    height: 200px;
    background: rgba(172, 147, 116, 0.1);
    border-radius: 4px;
    cursor: pointer;
    // padding: 20px;
    .booklistconse {
      width: 100%;
      height: 100%;
      // background: rgba(255, 255, 255, 0.6);
      border-radius: 4px;
      padding: 12px;
      display: flex;
      align-items: top;
      position: relative;
      border: 1px solid #eee;
      .playimg {
        width: 16px;
        height: 16px;
        position: absolute;
        right: 18px;
        top: 18px;
      }
      .imgcontent {
        width: 120px;
        height: 176px;
        margin-right: 10px;
      }
      .textline {
        width: 100%;
        height: 1px;
        background: #e5e5e5;
        margin: 5px 0;
      }
      .textcontent {
        flex: 1;
      }
      .texttitle {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 16px;
        color: #573E0D;
        letter-spacing: 0;
        line-height: 2;
      }
      .setitle {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #2B2B2B;
        letter-spacing: 0;
        line-height: 1.5;
        font-weight: 400;
      }
      .bcontent {
        width: 100%;
        // height: 100%;
        height: 105px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #2B2B2B;
        letter-spacing: 0;
        line-height: 1.6;
        text-align: justify;
        div {
          overflow: hidden;
        }

        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 5; /* 限制行数为5 */
        overflow: hidden;

        //   overflow: hidden;
        //   overflow-wrap: break-word;
        //   word-break: break-all; /* 对于非英文字符 */
        // }
      }
    }
  }
}
.newbooklist {
  height: 72vh;
  margin-top: 10px;
  overflow-y: hidden;

  .booklistc {
    cursor: pointer;
    width: 100%;
    // height: 100%;

    overflow-y: auto;
    .booklisten {
      height: 72vh;
      display: flex;
      // overflow-y: scroll;
      flex-wrap: wrap;
      // overflow-y: hidden;
      // overflow-y: auto;
      // justify-content: space-between;
      justify-content: flex-start;
      align-items: flex-start;
    }
  }

 /* .bookitem {
    width: 33%;
    height: 120px;
    padding: 15px 10px;
    display: flex;

    align-items: flex-start;
    border: 1px solid #eee;
    border-radius: 3px;
    margin: 4px;

    .righttext {
      flex: 1;
      .newbottomtext {
        p {
          overflow: hidden;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1; !* 限制行数为5 *!
          // overflow: hidden;
        }
        margin-top: 4px;

        line-height: 1.6;
      }
    }
    img {
      width: 60px;
      height: auto;
      margin-right: 5px;
      transition: transform 0.5s ease;
    }
    // .topbox {
    //   width: 200px;
    //   white-space: nowrap; !* 防止文本换行 *!
    //   overflow: hidden; !* 隐藏溢出的文本 *!
    //   text-overflow: ellipsis; !* 显示省略号来代表被修剪的文本 *!
    // }
    .toptext {
      text-align: left;
      font-size: 16px;
      color: #666666;
      letter-spacing: 0;
      font-weight: 700;
      line-height: 25px;
      font-family: PingFang-SC-Bold;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1; !* 限制行数为5 *!
      overflow: hidden;
    }
    .bottomtext {
      text-align: left;
      font-size: 14px;
      color: #666666;
      letter-spacing: 0;
      font-weight: 400;
      line-height: 1.5;
      font-family: PingFangSC-Regular;
    }
  }
  .bookitem:hover {
    img {
      transform: scale(1.1);
    }
    transform: scale(1.01);
    // .booklistconse {
    // background: rgba(255, 255, 255, 0.6);
    border: 0.5px solid rgba(44, 126, 141, 1);
    box-shadow: 0px 4px 8px 0px rgba(209, 203, 189, 0.4);
    // border-radius: 4px;
    // }
  }*/
  .bookitem {
    width: 170px;
    //height: 120px;
    padding: 16px;
    /*display: flex;

    align-items: flex-start;*/
    border: 1px solid #eee;
    border-radius: 3px;
    margin: 4px;

    .righttext {
      flex: 1;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 12px;
      color: #2B2B2B;
      .bottomtext {
        p {
          overflow: hidden;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1; /* 限制行数为5 */
          overflow: hidden;
        }
        margin-top: 4px;
        font-size: 12px;
        line-height: 17px;
      }
      .bookListStyle{
        color: #573E0D;
        margin-top: 4px;
        line-height: 17px;
        font-size: 14px;
      }
    }
    img {
      width: 60px;
      height: auto;
      margin-right: 5px;
      transition: transform 0.5s ease;
    }
    // .topbox {
    //   width: 200px;
    //   white-space: nowrap; /* 防止文本换行 */
    //   overflow: hidden; /* 隐藏溢出的文本 */
    //   text-overflow: ellipsis; /* 显示省略号来代表被修剪的文本 */
    // }
    .toptext {
      margin-top: 5px;
      text-align: left;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: #573E0D;
      letter-spacing: 0;
      line-height: 25px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1; /* 限制行数为5 */
      overflow: hidden;
    }
    .bottomtext {
      text-align: left;
      font-size: 14px;
      color: #666666;
      letter-spacing: 0;
      font-weight: 400;
      line-height: 1.5;
      font-family: PingFangSC-Regular;
    }
  }
  .bookitem:hover {
    img {
      transform: scale(1.1);
    }
    transform: scale(1.01);
    // .booklistconse {
    background: #FEFBF4;
    //border: 0.5px solid rgba(44, 126, 141, 1);
    box-shadow: 0px 4px 8px 0px rgba(209, 203, 189, 0.4);
    // border-radius: 4px;
    // }
  }
}
.booklistcon:hover {
  .imgcontent {
    transform: scale(1.1);
    transition: transform 0.3s linear;
  }
  .playimg {
    width: 17px;
    height: 17px;
    box-shadow: 0 2px 4px 0 rgba(209, 203, 189, 0.4);
  }
  .booklistconse {
     background: #FEFBF4;
    //border: 0.5px solid rgba(44, 126, 141, 1);
    box-shadow: 0px 4px 8px 0px rgba(209, 203, 189, 0.4);
    // border-radius: 4px;
    // transition: border 0.3s linear;
  }
}
// .submit-btn :hover,
// .submit-btn :focus {
//   background: #2c7e8d;
//   border-color: #2c7e8d;
//   color: #2c7e8d;
// }
/*.bottomtext {
  span {
    cursor: default;
  }
  position: absolute;
  bottom: -30px;
  left: 0;
  // font-size: 12px;
  width: 100%;
  padding: 8px 10px 10px;
  white-space: nowrap; !* 防止文本换行 *!
  overflow: hidden; !* 隐藏溢出的文本 *!
  text-overflow: ellipsis; !* 显示省略号 *!
  // transform: scaleX(-1) scaleY(-1);
  background: rgba(0, 0, 0, 0.2);
  border-radius: 4px 4px 0px 0px;
  font-family: PingFang-SC-Bold;
  font-size: 14px;
  color: #ffffff;
  letter-spacing: 0;
  line-height: 14px;
  font-weight: 700;
}*/
.box-readlist {
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  .readlistitem {
    width: 80%;
    display: flex;
    span {
      font-size: 12px;
      line-height: 4;
      width: 25%;
    }
  }
}
.querenbut {
  height: 30px;
  line-height: 30px;
  text-align: center;
  background: @first-color;
  border-radius: 10px;
  font-size: 14px;

  // font-weight: bold;
  color: #fff;
  cursor: pointer;
}
.bandcardstyle {
  display: flex;
  justify-content: space-between;
}
.smallfont {
  font-size: 12px;
  color: #e60012;
}
.redicon {
  color: #e60012;
}
p,
div {
  margin: 0;
  padding: 0;
}
img {
  width: 100%;
  height: 100%;
}
.ver {
  writing-mode: vertical-rl;
}
.textright {
  text-align: right;
}
.marginTop {
  margin-top: 56px;
}
.kaitem {
  width: 225px;
  height: 140px;
  background: #ffffff;
  box-shadow: 0px 3px 8px 2px rgba(125, 125, 125, 0.3);
  border-radius: 10px;
  color: #344672;
  display: flex;
  justify-content: space-between;
  font-family: "FangZheng-FanTi-Kaiti";
  overflow: hidden;
  .katitle {
    padding: 20px 0;
    font-size: 78px;
    line-height: 100px;
    font-weight: bold;
    margin-left: -16px;
    color: #1c3d85;
  }
  .kayue {
    flex: 1;
    display: flex;
    justify-content: space-between;
  }
  .kastart {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }
  .kaend {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  }

  .kacontent {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 0px;
  }
  .kades {
    font-size: 20px;
    font-weight: bold;
    color: #cc9933;
  }
}
/deep/.el-tooltip {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-content: start;
}
//.imgbccolor {
//filter: brightness(1.5) contrast(130%) saturate(103%);
//}
.qxbutton {
  width: 70px;
  height: 29px;
  line-height: 29px;
  background: @first-color;
  border-radius: 15px;
  color: #fff;
  font-size: 16px;
  font-weight: bold;
}
.zfbutton {
  margin-bottom: 10px;
}
/deep/.el-form-item {
  margin-bottom: 8px;
}
/deep/.avatar-uploader {
  display: flex;
  justify-content: center;
  // padding: 40px auto 8px;
}
.avatarborder {
  border: 1px dashed #d9d9d9;
  border-radius: 50px;
}
/deep/.avatar-uploader .el-upload {
  // border: 1px dashed #d9d9d9;
  // border-radius: 50px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.pointe {
  cursor: pointer;
}
/deep/.avatar-uploader .el-upload:hover {
  border-color:#DBB054;
}
/deep/.el-tabs__item.is-active {
  color: #DBB054;
}
/deep/.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
  border-radius: 50px;
}
/deep/.avatar {
  width: 100px;
  height: 100px;
  display: block;
  border-radius: 50px;
}

/deep/.el-form-item__label {
  // margin: 6px 0;
  // font-size: 20px;
  // font-weight: bold;
  // color: #a0a0a0;
  // text-align: left;
  // font-family: PingFang-SC-Regular;
  text-align: left;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #2B2B2B;
  letter-spacing: 0;
  // line-height: 14px;
  // line-height: 20px;
}
// /deep/.el-form-item {
//   margin-bottom: 8px;
// }
.fontstyle {
  // margin: 8px 0;
  // font-size: 20px;
  // font-weight: bold;
  // color: #a0a0a0;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #2B2B2B;
  letter-spacing: 0;
  // line-height: 14px;
  font-weight: 700;
  text-align: right;
}
.dialogimg {
  width: 18px;
  height: auto;
}
/deep/.el-dialog {
  margin-top: 3vh !important;
}
// /deep/.el-table .el-table__cell {
//   text-align: center;
// }
.zh-between {
  display: flex;
  line-height: 36px;
  ul {
    flex: 1;
  }
  li {
    min-height: 36px;
    white-space: normal;
    word-wrap: break-word;
  }
}
.between {
  // display: flex;
  // align-items: center;
  line-height: 36px;
  span {
    line-height: 36px;
    white-space: normal;
    word-wrap: break-word;
  }
}

.index {
  width: 100%;
  height: 100%;
  background: #f4f0e8;
  // background:

  .content-box {
    margin: 32px auto;
    //width: 1364px;
    // background: #fff;
   // display: flex;
    //justify-content: space-between;
    position: relative
  }
  .user-info {
    position: absolute;
    left: 20px;
    top:0;
    // flex: 1;
    // padding: 24px;
    // border-right: 1px solid #ccc;
    width: 400px;
    // width: 30.6%;
    background: #FEFBF4;
    border-radius: 8px;
    opacity: 0.8;
    // border-right: 2px solid #e4e7ed;
    .head-icon {
      width: 100px;
      height: 100px;
      display: block;
      margin: 40px auto 8px;
    }
    .user-name {
      font-size: 20px;
      font-weight: bold;
      color: #573E0D;
      text-align: center;
      margin-bottom: 44px;
      margin-top: 10px;
    }
    .shuline {
      width: 1px;
      height: 24px;
      background: rgba(44, 126, 141, 0.2);
      border-radius: 0.5px;
    }
    .read-list {
      width: 82px;
      // height: 71px;
      // background: #ecf5ff;
      // border-radius: 10px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      // padding: 10px 0;

      img,
      i {
        width: 24px;
        height: 24px;
        font-size: 28px;
        margin-bottom: 12px;
      }
      font-size: 17px;

      font-weight: bold;
      color: @secont-color;
    }
    .box-title {
      display: flex;
      justify-content: space-between;
      // font-size: 20px;

      // font-weight: bold;
      // color: #434343;
      width: 90%;
      height: 32px;
      //background: #f5f5f5;
      margin: 32px auto;

      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 18px;
      color: #573E0D;
      letter-spacing: 0;
      text-align: center;
      line-height: 16px;
      .editBox{
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #DBB054;
      }
      img {
        width: 16px;
        height: 16px;
        position: absolute;
        right: 20px;
        // margin: 0 8px;
      }
    }
    .user {
      .user-box {
        // width: 200px;
        font-family: @PingFangSC-Regular;
        width: 80%;
        /deep/.el-input__inner {
          // margin: 6px 0;
          font-size: 14px;
          font-weight: bold;
          // color: #a0a0a0;
          height: 30px;
          font-family: @PingFang-SC-Bold;
          color: #333333;
          letter-spacing: 0;
          line-height: 14px;
          font-weight: 700;
        }

        > div {
          margin: 8px 0;
          // font-size: 20px;

          // font-weight: bold;
          // color: #a0a0a0;
          font-size: 14px;
          color: #666666;
          letter-spacing: 0;
          // line-height: 14px;
          font-weight: 400;
          > label {
            min-width: 70px;
          }

          &.tag-block {
            margin: 16px 0;
            width: 100%;
            height: 32px;
            background: #DBB054;
            border-radius: 16px;
            // font-size: 18px;

            font-size: 14px;
            letter-spacing: 0;
            text-align: center;
            line-height: 14px;
            font-weight: 700;

            font-weight: bold;
            color: #fff;
            cursor: pointer;
            &.first-btn {
              margin-top: 54px;
            }
          }
          &.tag-block:hover {
            background: #DBB054;
            border-radius: 16px;
            // color: white;
            font-family: PingFang-SC-Bold;
            font-size: 14px;
            color: #fff;
            letter-spacing: 0;
            text-align: center;
            line-height: 14px;
            font-weight: 700;
          }
        }
      }
    }
  }

  .content {
    // flex: 1;
    // flex-grow: 1;
    //height: calc(100vh - 100px);
    background: #fff;
    padding: 24px;
    padding-bottom:0px;
    border-radius: 4px;
    margin-left: 450px;
    margin-right: 20px;
    .box-card {
      display: inline-block;
      margin-right: 8%;
      margin-bottom: 24px;
      // display: flex;
      width: 16%;
      // height: 202px;
      // width: 7rem;
      // height: 10rem;

      position: relative;

      .layer {
        // position: absolute;
        // left: 0;
        // top: 0;

        width: 100%;
        height: 100%;
        background: rgba(255, 255, 255, 0.5);
        display: flex;
      }
      .newlayer {
        font-family: PingFang-SC-Regular;
        font-size: 12px;
        a {
          color: rgba(255, 255, 255, 0.8);
        }
        letter-spacing: 0;
        line-height: 12px;
        font-weight: 400;
        background: none;
        img {
          width: 12px;
          height: 12px;
        }
        .newcenter {
          cursor: pointer;
          color: rgba(255, 255, 255, 0.8);
        }
      }
      &:hover {
        // .layer {
        //   display: flex;

        // }
        .bottomtext {
          bottom: 0;
          background: rgba(0, 0, 0, 0.4);
          transition: bottom 0.3s ease-in-out;
        }
      }
      &:nth-child(4n) {
        margin-right: 0;
      }

      .img {
        width: 100%;
        height: 100%;
      }
      .opera {
        > i {
          cursor: pointer;
        }
      }

      .process,
      .info {
        position: absolute;
        right: 0;
        top: 0;
        padding: 4px 8px;
        background: rgba(0, 0, 0, 0.5);
        font-size: 14px;
        color: #fff;
        box-sizing: border-box;
      }
      .info {
        top: initial;
        bottom: 0;
        width: 100%;
      }
    }

    .list-card {
      padding: 10px;
      margin-bottom: 16px;
      width: 47%;
      margin-right: 2%;
      .batch-btn {
        > a {
          font-size: 14px;
          padding: 8px;
          font-weight: bold;
          color: #3366cc;
          border-radius: 12px;
          img {
            width: 16px;
            margin-right: 4px;
          }
        }
      }

      .book-info {
        flex: 1;
        flex-grow: 1;
        > img {
          width: 74px;
          height: 105px;
          margin-right: 15px;
          margin-left: 15px;
        }
        .title {
          display: flex;
          justify-content: space-between;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 16px;
          color: #573E0D;
          line-height: 30px;
          .totalBox{
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #DBB054;
          }
        }
        .desc {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 12px;
          color: #2B2B2B;
        }
        .lookCancel{
          display: flex;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: #573E0D;
          margin-top: 25px;
          div{
            width: 50%;
          }
        }
      }
    }

    .btn {
      // height: 1.23rem;

      border-radius: 1rem;
      padding: 0.4rem 0.8rem;
      font-size: 0.73rem;

      font-weight: bold;
      background: #ffffff;
      color: #DBB054;
      border: none;
      margin: 0.5rem 0;

      /*&.active {
        background: #3366cc;
        color: #ffffff;
      }*/

      img {
        width: 0.73rem;
        height: auto;
        margin-right: 0.3rem;
      }
      i {
        margin-right: 0.3rem;
      }
    }


  }
}

.sm-title {
  font-size: 14px;

  font-weight: bold;
  color: #3366cc;

  &.justify-center {
    // width: 60px;
    .align-center {
      margin-bottom: 28px;
      text-decoration: none;
      color: #3366cc;

      cursor: pointer;
      &:last-child {
        margin-bottom: 0;
      }
    }
    img {
      width: 18px;
      height: auto;
    }
  }
}
.sm-titlen {
  // flex-direction: row;
  margin: 8px 0;
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.margin24 {
  margin: 12px 0;
}
.vip-card {
  .title {
    text-align: center;
  }
  .card-ipt {
    margin: 24px 0;
  }
  .explain {
    padding: 24px;
  }
}
/deep/ .el-tabs--left .el-tabs__header.is-left {
  float: none;
}
/deep/ .el-card__body {
  height: 100%;
  padding: 0;
  position: relative;
}
.select-content {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  padding: 1.4rem;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 4px;
  min-height: 580px;
  background: #fff;
  h2 {
    font-family: PingFang-SC-Bold;
    font-size: 32px;
    color: #2c7e8d;
    letter-spacing: 0;
    text-align: center;
    line-height: 32px;
    font-weight: 700;
  }
  p {
    font-family: PingFang-SC-Medium;
    font-size: 14px;
    color: #666666;
    letter-spacing: 0;
    line-height: 20px;
    font-weight: 500;
  }
  .booklist {
    height: 580px;
    margin-top: 10px;
    overflow-y: hidden;

    .booklistc {
      cursor: pointer;
      // height: 100%;
      width: 100%;
      overflow-y: auto;
      .booklisten {
        height: 72vh;
        display: flex;
        // overflow-y: scroll;
        flex-wrap: wrap;
        // overflow-y: hidden;
        // overflow-y: auto;
        // justify-content: space-between;
        justify-content: flex-start;
        align-items: flex-start;
      }
    }

    .bookitem {
      width: 164px;
      //height: 120px;
      padding: 12px;
      /*display: flex;

      align-items: flex-start;*/
      //border: 1px solid #eee;
      border-radius: 8px;
      margin: 4px;
      .righttext {
        flex: 1;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #2B2B2B;
        .bottomtext {
          p {
            overflow: hidden;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1; /* 限制行数为5 */
            overflow: hidden;
            font-size: 12px;
          }
          margin-top: 4px;
          line-height: 17px;
        }
        .bookListStyle{
          color: #573E0D;
          margin-top: 4px;
          line-height: 17px;
          font-size: 14px;
        }
      }
      img {
        width: 60px;
        height: auto;
        margin-right: 5px;
        transition: transform 0.5s ease;
      }
      // .topbox {
      //   width: 200px;
      //   white-space: nowrap; /* 防止文本换行 */
      //   overflow: hidden; /* 隐藏溢出的文本 */
      //   text-overflow: ellipsis; /* 显示省略号来代表被修剪的文本 */
      // }
      .toptext {
        margin-top:16px;
        text-align: left;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 16px;
        color: #573E0D;
        letter-spacing: 0;
        line-height: 25px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1; /* 限制行数为5 */
        overflow: hidden;
      }
      .bottomtext {
        text-align: left;
        font-size: 14px;
        color: #666666;
        letter-spacing: 0;
        font-weight: 400;
        line-height: 1.5;
        font-family: PingFangSC-Regular;
      }
    }
    .bookitem:hover {
      img {
        transform: scale(1.1);
      }
      transform: scale(1.01);
      // .booklistconse {
      background: #FEFBF4;
      //border: 0.5px solid rgba(44, 126, 141, 1);
      box-shadow: 0px 4px 8px 0px rgba(209, 203, 189, 0.4);
      // border-radius: 4px;
      // }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/uc/index.vue